export const RESET_REDUX_STATE = 'RESET_REDUX_STATE'
export const UPDATE_ADMIN_STATE = 'UPDATE_ADMIN_STATE'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'

